module.exports = __webpack_public_path__ + "img/background_section5-3.11dbd82d.svg";